import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-gracias',
    templateUrl: './gracias.component.html',
    styleUrls: ['./gracias.component.css']
})
export class GraciasComponent implements OnInit {
    private timeoutId: any;

    constructor(private router: Router) { }

    ngOnInit() {
        // No hacer nada al iniciar
    }

    volverAlInicio() {
        this.router.navigate(['/']);
    }

    ngOnDestroy() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }
} 